import {
  FormControl,
  FormControlProps,
  FormHelperText,
  InputLabel,
  InputLabelProps,
  MenuItem,
  MenuItemProps,
  Select,
  SelectProps,
} from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useErrorMessageResolver } from '../../localization/useErrorMessageResolver';

export type FormSelectProps = {
  control: Control<any>;
  name: string;
  label: string;
  options: ({ label: string; value: string } & Omit<MenuItemProps, 'value'>)[];
  selectFieldProps?: Partial<SelectProps>;
  labelProps?: Partial<InputLabelProps>;
  helperText?: string;
  readonly?: boolean;
} & Omit<FormControlProps, 'name'>;
export const FormSelect = ({
  control,
  name,
  label,
  options,
  selectFieldProps,
  labelProps,
  helperText,
  readonly,
  ...formControlProps
}: FormSelectProps) => {
  const resolveErrorMessage = useErrorMessageResolver();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, ...fieldRest }, fieldState: { error } }) => (
        <FormControl fullWidth {...formControlProps} variant={readonly ? 'standard' : formControlProps.variant}>
          <InputLabel
            id={`${name}-select-label`}
            error={!!error}
            {...labelProps}
            sx={{
              ...(labelProps?.sx ?? {}),
              bgcolor: 'white',
            }}
          >
            {label}
          </InputLabel>
          <Select
            {...selectFieldProps}
            {...fieldRest}
            variant={readonly ? 'standard' : selectFieldProps?.variant}
            value={fieldRest.value ?? ''}
            id={`${name}-select`}
            labelId={`${name}-select-label`}
            MenuProps={{ PaperProps: { variant: 'outlined' } }}
            readOnly={readonly ?? selectFieldProps?.readOnly}
            disableUnderline={readonly}
            ref={ref}
          >
            {options.map(({ value, label, ...rest }) => (
              <MenuItem {...rest} key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
          {error?.message || helperText ? (
            <FormHelperText error={!!error?.message}>
              {error?.message ? resolveErrorMessage(error.message) : helperText}
            </FormHelperText>
          ) : null}
        </FormControl>
      )}
    />
  );
};
